<template>
  <v-dialog
    v-model="localDialog"
    width="35%"
    @update:modelValue="updateDialog"
    transition=""
    persistent
    :open-delay="0"
    :close-delay="0"
  >
    <v-card>
      <v-card-title class="text-h6">
        <span>{{ isEntryMode ? "Add Shift" : "Update Shift" }}</span>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-form @submit.prevent="submit" ref="ShiftSetup">
          <v-row>
            <v-col cols="12">
              <v-text-field
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="shift_name.value.value"
                :error-messages="shift_name.errorMessage.value"
                clearable
              >
								<template #label>
										Shift Name
										<span class="text-red-accent-4">*</span>
								</template>
							</v-text-field>

              <v-menu
                v-model="inTimeMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template #activator="{ props }">
                  <v-text-field
                    v-bind="props"
                    label="In Time"
                    v-model="in_time.value.value"
                    readonly
                    variant="outlined"
                    density="compact"
                    bg-color="grey-lighten-4"
                    prepend-icon="mdi-clock-time-four-outline"
                    :error-messages="in_time.errorMessage.value"
                    clearable
                  >
										<template #label>
											In Time
												<span class="text-red-accent-4">*</span>
										</template>
									</v-text-field>
                </template>

                <v-time-picker
                  v-model="in_time.value.value"
                  full-width
                  @click:minute="inTimeMenu = false"
                />
              </v-menu>

              <v-menu
                v-model="outTimeMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template #activator="{ props }">
                  <v-text-field
                    v-bind="props"
                    label="Out Time"
                    v-model="out_time.value.value"
                    readonly
                    variant="outlined"
                    density="compact"
                    bg-color="grey-lighten-4"
                    prepend-icon="mdi-clock-time-four-outline"
                    :error-messages="out_time.errorMessage.value"
                    clearable
                  >
										<template #label>
											Out Time
											<span class="text-red-accent-4">*</span>
										</template>
									</v-text-field>
                </template>

                <v-time-picker
                  v-model="out_time.value.value"
                  full-width
                  @click:minute="outTimeMenu = false"
                />
              </v-menu>

             <v-text-field
              label="Late Time (minutes)"
              v-model.number="late_time.value.value"
              type="number"
              min="0"
              step="1"
              @input="late_time.value.value = Math.max(0, Math.floor(late_time.value.value || 0))"
              variant="outlined"
              density="compact"
              prepend-icon="mdi-clock-time-four-outline"
            />

              <v-text-field
                label="Remarks (Optional)"
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
                v-model="remarks.value.value"
                :error-messages="remarks.errorMessage.value"
                clearable
              ></v-text-field>

              <v-checkbox
                label="Active"
                v-model="status.value.value"
                :error-messages="status.errorMessage.value"
                density="compact"
                variant="outlined"
                hide-details
                single-line
                color="primary"
                value="1"
              ></v-checkbox>
              <input v-model="shift_id.value.value" type="hidden" />
            </v-col>
          </v-row>

          <v-divider></v-divider>
          <v-card-actions>
            <v-layout class="justify-end">
              <v-btn class="bg-red" @click="closeDialog">Close</v-btn>
              <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">
                {{ isEntryMode ? "Save" : "Update" }}
              </v-btn>
            </v-layout>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import { fileServerUrl } from "@/store/api";

export default {
  name: "ShiftSetup",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({
        name: "",
        remarks: "",
        status: "1",
        shift_id: null,
      }),
    },
  },
  data() {
    return {
      localDialog: this.dialog,
      errorMessages: "",
      loading: false,
      isEntryMode: true,
      inTimeMenu: false,
      outTimeMenu: false,
      lateTimeMenu: false,
    };
  },
  computed: {},
  watch: {
    dialog(val) {
      this.localDialog = val;
    },
    localDialog(val) {
      this.$emit("update:dialog", val);
    },
    data: {
      handler(newData) {
        this.shift_id.setValue(newData.id || "", false);
        this.shift_name.setValue(newData.shift_name || "", false);
        this.in_time.setValue((newData.in_time || "").slice(0, 5), false);
        this.out_time.setValue((newData.out_time || "").slice(0, 5), false);
        this.late_time.setValue(newData.late_time || "", false);
        this.remarks.setValue(newData.remarks || "", false);
        this.status.setValue(String(newData.status ?? "1"), false);
      },
    },
  },
  created() {},
  methods: {
    updateDialog(val) {
      this.$emit("update:dialog", val);
    },
    closeDialog() {
      this.$emit("update:dialog", false);
    },
  },
  setup(props, { emit }) {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        shift_name: yup
          .string()
          .min(4)
          .max(50)
          .required()
          .trim()
          .label("Weekend Day"),
        in_time: yup
          .string()
          .required()
          .matches(
            /^([01]\d|2[0-3]):([0-5]\d)$/,
            "Late Time must be in HH:mm format"
          )
          .label("In Time"),
        out_time: yup
          .string()
          .required()
          .matches(
            /^([01]\d|2[0-3]):([0-5]\d)$/,
            "Late Time must be in HH:mm format"
          )
          .label("Out Time"),
        late_time: yup.string().nullable().label("Late Time"),
        remarks: yup.string().max(250).nullable().trim().label("Remarks"),
      }),
    });

    const shift_id = useField("shift_id");
    const shift_name = useField("shift_name");
    const in_time = useField("in_time");
    const out_time = useField("out_time");
    const late_time = useField("late_time");
    const remarks = useField("remarks");
    const status = useField("status");
    const errorMessages = ref("");
    const loading = ref("");
    const store = useStore();

    const submit = handleSubmit((values) => {
      store
        .dispatch("saveUpdateShift", values)
        .then((response) => {
          resetForm();
          emit("update:dialog", false);
          toast.success(response.data.message);
          loading.value = true;
          store
            .dispatch("getShiftList")
            .then((data) => {
              loading.value = false;
            })
            .catch((error) => {
              loading.value = false;
              toast.error(error.response.data.message);
            });
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    });
    return {
      submit,
      remarks,
      shift_name,
      in_time,
      out_time,
      late_time,
      status,
      shift_id,
      errorMessages,
      resetForm,
      loading,
    };
  },
  mounted() {},
};
</script>
